import React, {useRef} from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import CustomerList from "./CustomerList";
import CustomerTypeTree from "./CustomerTypeTree";
import "./customer.less"
export default function () {
    const sRef = useRef();

    const searchForm = () => {
        return sRef.current.getSearchForm();
    }
    return (
        <>
            <div style={{height: "98%"}}>
                <Card
                    title={<h3>客户类型</h3>}
                    bordered={true}
                    className="margin-top-8"
                    style={{width: "250px", height: "100%",float:"left"}}
                >
                    <CustomerTypeTree/>
                </Card>
                <div className="margin-top-8 margin-left-8" style={{float:"right",width:"calc(100% - 258px)"}}>
                    <Card
                        bordered={true}
                        style={{display: "flex"}}
                    >
                        <div
                            style={{
                                margin: "8px 20px"
                            }}
                        >
                            <SearchForm sRef={sRef}/>
                        </div>
                    </Card>
                    <Card
                        bordered={true}
                        className="margin-top-8"
                        
                    >
                        <CustomerList sForm={searchForm}/>
                    </Card>
                </div>
            </div>
        </>
    )
}